"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTIFY_TYPE = void 0;
const NOTIFY_TYPE = exports.NOTIFY_TYPE = 'notify-type';
